import { Timeline } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import AnalysisWidget from "../../../../../../Analysis/widget";

const Style = styled.div`
  flex: 1;
  overflow-y: auto;
  max-height: 469px;
  padding: var(--size-lg);
  padding-bottom: 0px;

  .ant-timeline-item-label {
    width: calc(30% - 12px) !important;
  } 

  .ant-timeline-item-tail, .ant-timeline-item-head {
    inset-inline-start: calc(30% + 4px) !important;
  }

  .ant-timeline-item-content {
    inset-inline-start: calc(30% - 4px) !important;
    width: calc(70% - 12px) !important;
  }
`

export default function AmpTimeline({ data = [] }) {
  const { t } = useTranslation();

  return (
    <AnalysisWidget className="with-border-header custom-width-b no-p-body" title={t('Timeline')}>
      <Style>
        <Timeline
          mode="left"
          items={data}
        />
      </Style>
    </AnalysisWidget>
  );
}
